// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f5ee16f8ae070c9d7d23","883":"a60e6aea8c8820e7dab7"}[chunkId] + ".js";
};